export default __webpack_public_path__ + "static/media/Platinum.4c52c455.png";